const ROUTE_CONSTANTS = {
    ROOT: "/",
    ERROR: "/error",
    CONFIRMATION: "/confirmation",
};

export default ROUTE_CONSTANTS;
